import { Choice, ChoiceList } from '@cmsgov/ds-medicare-gov';
import { ComponentProps, PropsWithChildren } from 'react';
import '../css/checkbox.css';
import cloneObject from '../functions/cloneObject';

type DSChoiceProps = ComponentProps<typeof Choice>
type CheckboxProps = Pick<DSChoiceProps,
    'checked' |
    'className' |
    'name' |
    'onBlur' |
    'onChange' |
    'type' |
    'value' |
    'inputRef' |
    'label'
> & {
    title: string
    errorMessage?: string | null
}

const Checkbox = (props: PropsWithChildren<CheckboxProps>) => {
    const clonedProps = cloneObject(props);
    delete clonedProps.errorMessage;

    return <>
        <div>
            <ChoiceList
                choices={[{ label: props.title, value: props.value}]}
                label={props.label}
                {...clonedProps}
                errorMessage={props.errorMessage}
                labelClassName={"ds-u-measure--wide"}
            />
            {props.children}
        </div>
    </>
}

export default Checkbox;
